import { Box, BoxProps } from "@chakra-ui/react";
import { FiBriefcase } from "react-icons/fi";

export const BriefcaseIcon = (props: BoxProps) => {
  return <Box as={FiBriefcase} height="20px" width="20px" {...props} />;
};
